import React, { createContext, useContext, useState, useCallback } from 'react';

export interface AuthUser { email: string; name: string; role: string; }

interface AuthCtx {
  token: string | null;
  user: AuthUser | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AuthCtx>(null as unknown as AuthCtx);
export const useAuth = (): AuthCtx => useContext(Ctx);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('etl_token'));
  const [user, setUser] = useState<AuthUser | null>(() => {
    const u = localStorage.getItem('etl_user');
    return u ? (JSON.parse(u) as AuthUser) : null;
  });

  const login = useCallback(async (email: string, password: string) => {
    const r = await fetch('/api/v1/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const body = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(body.detail || 'Login failed');
    localStorage.setItem('etl_token', body.access_token);
    localStorage.setItem('etl_user', JSON.stringify(body.user));
    setToken(body.access_token);
    setUser(body.user);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('etl_token');
    localStorage.removeItem('etl_user');
    setToken(null);
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ token, user, login, logout }}>{children}</Ctx.Provider>;
};
